import AuthContainerPhoenix from "../../containers/auth/AuthContainerPhoenix";




export default {
	routeProps: {
		path: '/phoenix',
		exact: true,
		component: AuthContainerPhoenix,
	},
	name: 'PhoenixLogin',
};
